import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_publish",
  "use": "icon-icon_publish-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon_publish\"><path d=\"M350.912 605.376l-299.968-182.72 908.48-355.648-159.072 818.272-387.04-247.872L759.264 263.936zM416 704v209.92l128.256-130.208z\" fill=\"currentColor\" p-id=\"7486\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol